import * as dayjs from 'dayjs'
import 'dayjs/locale/es'

export const formatBs = (value) =>
  Number(value || 0).toLocaleString('es-BO', { minimumFractionDigits: 2 })

export const formatPeriodo = (periodo, granularidad) => {
  if (!periodo) return ''
  const d = dayjs(periodo).locale('es')
  if (granularidad === 'day') return d.format('DD/MM')
  if (granularidad === 'week') return `Sem. ${d.format('DD/MM')}`
  return d.format('MMM YYYY')
}

export const slugify = (text) =>
  (text || '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')

// Agrupa una lista ya ordenada desc en los N primeros + un balde "Otros" con el resto,
// para gráficas de participación (donut) que no se saturan con muchos vendedores.
export const topNConOtros = (items = [], n = 5) => {
  const top = items.slice(0, n)
  const restoTotal = items.slice(n).reduce((acc, i) => acc + (i.total || 0), 0)
  const labels = top.map((i) => i.nombre)
  const data = top.map((i) => i.total)
  if (restoTotal > 0) {
    labels.push('Otros')
    data.push(restoTotal)
  }
  return { labels, data }
}
